var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconInspector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_0_54)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.975501 7.04589C1.40915 6.35965 2.10458 5.47438 3.02669 4.72688C4.09799 3.85845 5.4325 3.20833 7 3.20833C8.5675 3.20833 9.90201 3.85845 10.9733 4.72688C11.8954 5.47438 12.5908 6.35965 13.0245 7.04589C12.6797 7.67213 12.0104 8.5265 11.0707 9.26808C9.96921 10.1374 8.57272 10.7917 7 10.7917C5.42728 10.7917 4.03079 10.1374 2.9293 9.26808C1.9896 8.5265 1.32026 7.67213 0.975501 7.04589ZM7 2.33333C3.35406 2.33333 0.908318 5.36757 0.0183693 6.94127C-0.00306602 6.97917 -0.00597856 7.02208 0.0108803 7.06222C0.672247 8.63692 3.35675 11.6667 7 11.6667C10.6432 11.6667 13.3278 8.63692 13.9891 7.06222C14.006 7.02208 14.0031 6.97917 13.9816 6.94127C13.0917 5.36757 10.6459 2.33333 7 2.33333ZM8.45833 7C8.45833 7.80542 7.80542 8.45833 7 8.45833C6.19458 8.45833 5.54167 7.80542 5.54167 7C5.54167 6.19458 6.19458 5.54167 7 5.54167C7.80542 5.54167 8.45833 6.19458 8.45833 7ZM7 9.33333C8.28866 9.33333 9.33333 8.28866 9.33333 7C9.33333 5.71134 8.28866 4.66667 7 4.66667C5.71134 4.66667 4.66667 5.71134 4.66667 7C4.66667 8.28866 5.71134 9.33333 7 9.33333Z",
    fill: "var(--fill-0, white)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_54"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInspector);
export default __webpack_public_path__ + "static/media/iconInspector.4470ea2d93fa0434dd9eec90f3a615ff.svg";
export { ForwardRef as ReactComponent };